import { motion } from 'framer-motion';

// Reusable scroll-reveal wrapper. Children fade + rise into place the first
// time they cross into the viewport, then stay put (viewport.once) so the
// animation never re-triggers while scrolling back up.
function FadeIn({ children, delay = 0, y = 28, className, as = 'div', ...rest }) {
  const Component = motion[as] ?? motion.div;
  return (
    <Component
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </Component>
  );
}

export default FadeIn;
